import React from 'react';

import Paper from '@material-ui/core/Paper';

import classes from './NoTechniciansPage.module.css';

const NoTechniciansPage = ({
    ...props
}) => {
    return (
        <Paper className={classes.noTechniciansPanel}>
            <div className={classes.noTechniciansContainer}>
                <div className={classes.emoContainer}>
                    <img src="/assets/images/emo.svg" alt="emo icon" /> 
                    <h2>Select a Technician from the list, or don't, whatever.</h2>
                </div>
            </div>
        </Paper>
    );
};

export default NoTechniciansPage;
